import { useFlag } from '@calendly/feature-check-react';
import { SearchForm } from '@calendly/form';
import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { historyPush } from 'actions/core/navigation';
import { changedMeetingFilters, useIsMyCalendlyScope } from 'components/meetings/filter_modal/utils';
import { useFetchMeetingsFilterCountForAnalytics } from 'features/meetings/hooks/use_results_count';
import { mapChangedFiltersForAnalytics } from 'features/meetings/utils';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { useFilters } from 'hooks/meetings/filters';
const containerCss = "c1n7j5sq";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const SearchLegacy = ({
  initialValue = ''
}) => {
  const dispatch = useDispatch();
  const handleSubmit = searchQuery => {
    // return statement needed to keep current logic of the search page. Might remove in a follow up
    if (!searchQuery) return;
    dispatch(historyPush(`/app/meetings/search?${buildQuery({
      query: searchQuery
    })}`));
  };
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSubmit(event.target.value);
    }
  };
  return <Container>
      <SearchForm initialValue={initialValue} placeholder={I18n.t('publisher.meetings.search.placeholder')} onKeyPress={handleKeyPress} isFullSized />
    </Container>;
};
const SearchMeetingsPage = ({
  initialValue = '',
  filterDefaults = {}
}) => {
  const history = useHistory();
  const track = useTrack();
  const {
    getFilterParams
  } = useFilters();
  const filterParams = getFilterParams(filterDefaults);
  const isMyCalendlyScope = useIsMyCalendlyScope();
  const fetchResultsCountForAnalytics = useFetchMeetingsFilterCountForAnalytics(filterDefaults);
  const sendAnalytics = useCallback((searchQuery, resultsCount) => {
    const paramsForAnalytics = {
      ...filterParams,
      search_keyword: searchQuery
    };
    const changedFilters = changedMeetingFilters(true, isMyCalendlyScope, paramsForAnalytics);
    const properties = {
      results_count: resultsCount,
      search_type: 'text',
      location: 'meetings_page',
      filters: mapChangedFiltersForAnalytics(changedFilters),
      search_text: searchQuery
    };
    track({
      name: TRACKING_EVENT_NAMES.SEARCH_PERFORMED,
      properties
    });
  }, [filterParams, isMyCalendlyScope, track]);
  const updateSearchParam = value => {
    const params = new URLSearchParams(history.location.search);
    if (value) {
      params.set('search_keyword', value);
    } else {
      params.delete('search_keyword');
    }
    history.replace({
      ...history.location,
      search: params.toString()
    });
  };
  const handleSubmit = async searchQuery => {
    updateSearchParam(searchQuery);
    if (searchQuery) {
      // Removing search query shouldn't trigger an analytic event
      const resultsCount = await fetchResultsCountForAnalytics(searchQuery);
      sendAnalytics(searchQuery, resultsCount);
    }
  };
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSubmit(event.target.value);
    }
  };
  const handleSearchButtonClick = value => {
    // Only handle clear button clicks (empty value)
    // Regular searches should only happen on Enter key
    if (!value) {
      updateSearchParam('');
    }
  };
  return <Container>
      <SearchForm onSearch={handleSearchButtonClick} initialValue={initialValue} placeholder={I18n.t('publisher.meetings.search.placeholder')} onKeyPress={handleKeyPress} isFullSized />
    </Container>;
};
export const Search = ({
  initialValue = '',
  filterDefaults = {}
}) => {
  const meetingsPageSearch = useFlag('scheduling_meetings_page_search');
  if (meetingsPageSearch) {
    return <SearchMeetingsPage initialValue={initialValue} filterDefaults={filterDefaults} />;
  }
  return <SearchLegacy initialValue={initialValue} />;
};

require("./search.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search.js");